import React from 'react';

const DeliveryMenu = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
  >
    <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
      <g fill="#9b9b9b" fillRule="nonzero" transform="translate(-24 -608)">
        <g transform="translate(0 80)">
          <g>
            <g transform="translate(0 432)">
              <g transform="translate(0 72)">
                <g transform="translate(24 24)">
                  <path d="M12.264 2.23a.755.755 0 01.598.03l9.264 4.558.055.03a.741.741 0 01.363.687.146.146 0 01.001.023v9.754a.75.75 0 01-.424.675l-9.263 4.482a.746.746 0 01-.495.058.74.74 0 01-.443-.036l-.05-.022-9.264-4.482a.75.75 0 01-.422-.614l-.002-.061V7.558c0-.388.285-.684.63-.741a.664.664 0 01.125-.077L12.2 2.257zM3.687 8.72v8.122l7.758 3.754v-8.38l-1.618-.73v1.817A.752.752 0 018.796 14l-.05-.023-2.687-1.303a.75.75 0 01-.42-.613L5.635 12V9.598l-1.95-.878zm17.353 0l-7.758 3.496v8.38l7.758-3.754V8.72zm-.914 6.646a.562.562 0 01-.203.729l-.048.027-.952.477a.562.562 0 01-.555-.979l.048-.026.952-.478a.565.565 0 01.758.25zm-.008-1.8a.562.562 0 01-.215.726l-.048.026-2.475 1.194a.562.562 0 01-.54-.987l.049-.027 2.475-1.193a.565.565 0 01.754.261zM15.617 5.29L7.24 9.227l-.004.01a.76.76 0 01-.022.044c-.011.06-.03.121-.056.18l-.018.032v2.037l1.181.573V10.3a.75.75 0 01.376-.65l.055-.028 8.003-3.773-1.14-.56zm2.86 1.408l-7.387 3.482 1.442.662 7.5-3.38-1.554-.764zm-5.95-2.93l-7.501 3.63 1.306.598 7.56-3.555-1.366-.672z"></path>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default DeliveryMenu;
